export default __webpack_public_path__ + "static/media/online-icon.9621df62.gif";